export const SCAN_CARD_STATE_KEY = 'scanCard';
